<template>
  <SdsMegaMenuItem
    v-if="item?.type === 'link' || item?.type === 'page'"
    class="gtm-2-mm h-fit"
    :class="{
      'col-span-1': i !== 0,
      'col-span-2': i === 0
    }"
    :href="
      item?.type === 'link' ?
        item?.value?.page_or_url?.custom_url :
        item?.value?.page_or_url?.page
    "
    :target="
      item?.value?.page_or_url?.new_window ?
        '_blank' :
        null
    "
    :rel="
      item?.value?.page_or_url?.new_window ?
        'noopener noreferrer' :
        null
    "
    :external="item?.value?.link_type?.external ?? null"
    :type="item?.value?.link_type?.style ?? null"
    :label="item?.value?.label ?? null"
    :cta="
      item?.value?.link_type?.external ?
        null :
        item?.value?.link_type?.cta ?? null"
  >
    <span
      v-if="item?.value?.link_type?.style === 'descriptive'"
      class="text-sm text-gray-400"
    >{{ item?.value?.link_type?.description }}</span>
  </SdsMegaMenuItem>
  <template v-if="item?.type === 'feed'">
    <SdsMegaMenuItem
      v-for="(feed_item, idx) in feed(item)"
      :key="feed_item['href'].split('/')[-1]"
      class="gtm-2-mm h-fit"
      :label="feed_item['title']"
      :href="feed_item['href']"
      :external="feed_item['external']"
    >
      <template
        v-if="hasPrimaryImage(item) && idx === 0"
        #top
      >
        <FocalImage
          :image="{ url: feed_item['image'], alt: feed_item['image_alt'] || feed_item['title'] }"
          img-class="mb-2 w-full"
        />
      </template>
      <template v-if="['jobs', 'news', 'blog'].includes(item.value.feed)">
        <span
          v-if="feed_item['location']"
          class="text-xs text-gray-400 flex flex-row flex-wrap gap-x-2"
        >
          <span>{{ feed_item['date'] }}</span>
          <span>&bull;</span>
          <span>{{ feed_item['location'] }}</span>
        </span>
        <span
          v-else
          class="text-xs uppercase font-bold text-gray-400"
        >{{ feed_item['date'] }}</span>
      </template>
      <template
        v-if="item.value.feed === 'events' && feed_item['start_date']"
        #left
      >
        <div class="leading-5 size-[4.5rem] transition-all bg-gray-50 group-hover:bg-gray-100 text-gray-900 p-4 text-center">
          <div class="text-gray-400 leading-none">
            {{ monthFromDate(feed_item['start_date']) }}
          </div>
          <div class="text-2xl text-gray-400">
            {{ dayFromDate(feed_item['start_date']) }}
          </div>
        </div>
      </template>
      <template
        v-if="item.value.feed === 'events'"
      >
        <p
          v-if="feed_item['span']"
          class="mt-1 text-xs uppercase font-bold text-gray-400"
        >
          {{ feed_item['span'] }}
        </p>
        <p
          v-if="feed_item['description']"
          class="mt-1 text-xs text-gray-400 line-clamp-2 text-ellipsis"
        >
          {{ feed_item['description'] }}
        </p>
      </template>
      <template
        v-if="item.value.feed === 'courses'"
      >
        <p
          v-if="feed_item['span']"
          class="mt-1 text-xs uppercase font-bold text-gray-400"
        >
          {{ feed_item['span'] }}
        </p>
      </template>
    </SdsMegaMenuItem>
  </template>
</template>

<script setup lang="ts">
/**
 * NOTE:
 * Track clicks on a panel-level item with the .gtm-2-mm class;
 * consult with Laura Aguera if  this needs to be updated.
 * Dan — 06/18/2024
 */

const feed = (item) => {
  return item.value.feed_items
}

const hasPrimaryImage = (item) => {
  return item.value.primary_image
}

const monthFromDate = (date) => {
  return new Date(date).toLocaleString('default', { month: 'short' })
}

const dayFromDate = (date) => {
  return new Date(date).getDate()
}

defineOptions({
  name: "MenuItem"
})

defineProps({
  i: { type: Number, default: 0 },
  item: { type: Object, default: () => {} },
})
</script>
